export const config : any = {
  deployments: {
    1: {
      subgraphUrl: '',
      subgraphSubscription: '',
      rpcURL: 'https://mainnet.infura.io/v3/d99575fce2fe4a17a17f47685be4711d',
      networkName: 'ethereum',
      scanner:  'https://etherscan.io/',
      vesting: '',
      shra: {
        instanceAddress: {
          '1': '',
          '10': '',
          '100': '',
          '1000': '',
          '10000': '',
        },
        tokenAddress: '0xD7B1387d43359eDfC858d946810c067817A3f959',
        blockHeight: 0, 
        symbol: 'SHRA',
        decimals: 18,
      },
    },
    3: {
      subgraphUrl: '',
      subgraphSubscription: '',
      rpcURL: '',
      networkName: 'ropsten',
      scanner:  'https://ropsten.etherscan.io/',
      shra: {
        relayer: 'https://sahara-relay.superhow.net',
        vesting: '0x2bf8333bfd0c8fBDd1F76647eE879d3d44d8E30c',
        instanceAddress: {
          '1': '0xeb9479C35331aE7e99eca7E73538BbD38936d449',
          '10': '0x25c144AfF56092674d0F5469fe5261A77D9ee376',
          '100': '0x21A60D1EC760F764ca8094d68D4883ADF72B1953',
          '1000': '0x660f770cf83aDdE8DCC54b4fabae0C35238bc7Fb',
          '10000': '0xDA91A03A4f8E3fFBfc1E7D9c09ec9Bc9f0591660',
        },
        tokenAddress: '0xC26665C0C9625378bb214E179C6ccaFc9d0b1063',
        blockHeight: 11524896, 
        symbol: 'SHRA',
        decimals: 18,
      },
    },
    // 80001: {
    //   subgraphUrl: 'https://mumbai-subgraph.sahara.superhow.net/subgraphs/name/sahara/mumbai-sahara-subgraph',
    //   subgraphSubscription: '',
    //   rpcURL:'https://rpc-mumbai.maticvigil.com/v1/3e6fbf872f3d8a58d8a0ad233b2dea81db1c879f',
    //   networkName: 'mumbai',
    //   scanner:  'https://mumbai.polygonscan.com/',
    //   shra: {
    //     relayer: 'https://sahara-relay.superhow.net/mumbai',
    //     vesting: '0x52E5B0c545808abE5cB9f8A0B9b460A40643B317',
    //     instanceAddress: {
    //       '1': '0xE423FF3A07B1ff046d08C8f4EC3e1aDBe5Df2968',
    //       '10': '0xfE9Da45362E4A162861e8c141E483736EBCbcAc6',
    //       '100': '0x65eD7d5F2caD633d24E5Dc73B42a8188ee6F71da',
    //       '1000': '0x6fb319e3401c7537f9ffE07da7557A6EEe6c7776',
    //       '10000': '0x04fFDe971Fe781a3196556f0833fc281f65bfAc8',
    //     },
    //     tokenAddress: '0x4B69b25d6bb0619D0a92993340F1265ecfC05756',
    //     blockHeight: 25549741, 
    //     symbol: 'SHRA',
    //     decimals: 18,
    //   },
    // },
    137: {
      subgraphUrl: '',
      subgraphSubscription: '',
      rpcURL: 'https://polygon-rpc.com',
      networkName: 'polygon',
      scanner:  'https://polygonscan.com/',
      shra: {
        relayer: '',
        vesting: '0x26Af9DC99Cc0648068760fE862CbA1542577BfE0',
        instanceAddress: {
          '1': '',
          '10': '',
          '100': '',
          '1000': '',
          '10000': '',
        },
        tokenAddress: '0xD7B1387d43359eDfC858d946810c067817A3f959',
        blockHeight: 25807990,
        symbol: 'SHRA',
        decimals: 18,
      },
    },
  },
};